<template>
  <path
    d="M20 11.0002H4C3.45 11.0002 3 11.4502 3 12.0002C3 12.5502 3.45 13.0002 4 13.0002H20C20.55 13.0002 21 12.5502 21 12.0002C21 11.4502 20.55 11.0002 20 11.0002ZM4 18.0002H14C14.55 18.0002 15 17.5502 15 17.0002C15 16.4502 14.55 16.0002 14 16.0002H4C3.45 16.0002 3 16.4502 3 17.0002C3 17.5502 3.45 18.0002 4 18.0002ZM20 6.00024H4C3.45 6.00024 3 6.45024 3 7.00024V7.01024C3 7.56024 3.45 8.01024 4 8.01024H20C20.55 8.01024 21 7.56024 21 7.01024V7.00024C21 6.45024 20.55 6.00024 20 6.00024Z"
  />
</template>
